// extracted by mini-css-extract-plugin
module.exports = {"common":"ContactsAlphabet_common__3ciW0"};